var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMytDurationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.125C3.65117 0.125 0.125 3.65117 0.125 8C0.125 12.3488 3.65117 15.875 8 15.875C12.3488 15.875 15.875 12.3488 15.875 8C15.875 3.65117 12.3488 0.125 8 0.125ZM11.1025 10.4205L10.5998 11.1061C10.5889 11.121 10.5751 11.1336 10.5593 11.1432C10.5434 11.1528 10.5259 11.1591 10.5076 11.1619C10.4893 11.1647 10.4706 11.1638 10.4527 11.1594C10.4347 11.1549 10.4178 11.1469 10.4029 11.1359L7.49551 9.01602C7.4774 9.00301 7.46267 8.98584 7.45258 8.96596C7.44248 8.94607 7.43731 8.92406 7.4375 8.90176V4.0625C7.4375 3.98516 7.50078 3.92188 7.57812 3.92188H8.42363C8.50098 3.92188 8.56426 3.98516 8.56426 4.0625V8.41309L11.0709 10.2254C11.1342 10.2693 11.1482 10.3572 11.1025 10.4205Z",
    fill: "black",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMytDurationIcon);
export default __webpack_public_path__ + "static/media/myt-duration-icon.37d1d3e39662870620730061b49bfcc9.svg";
export { ForwardRef as ReactComponent };